module.exports = __webpack_public_path__ + "static/img/CNN-Default.be00fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/CNN-Default.png
// module id = 1567
// module chunks = 0